import { useMemo } from 'react';
import { useMarketingAreaContext } from './MarketingAreaContext';
import { MarketingContent } from './MarketingContent';

export function MarketingArea() {
  const { customComponent, isHidden } = useMarketingAreaContext();

  const expectedMarketingAreaComponent = useMemo(() => {
    if (isHidden === true) {
      return null;
    } else if (customComponent !== undefined) {
      return customComponent;
    } else {
      return <MarketingContent />;
    }
  }, [customComponent, isHidden]);

  return <>{expectedMarketingAreaComponent}</>;
}
